"use client";

// src/components/default/document-doc.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var DocumentDocIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `DocumentDocIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `DocumentDocIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            d: "M7.74898 14.7917H12.2439C12.3974 14.7917 12.5271 14.7403 12.6328 14.6375C12.7386 14.5346 12.7915 14.4069 12.7915 14.2545C12.7915 14.102 12.7397 13.9728 12.6362 13.8671C12.5327 13.7613 12.4041 13.7084 12.2506 13.7084H7.75571C7.60221 13.7084 7.47258 13.7598 7.36682 13.8627C7.26105 13.9655 7.20817 14.0932 7.20817 14.2457C7.20817 14.3982 7.25993 14.5273 7.36344 14.6331C7.46697 14.7388 7.59548 14.7917 7.74898 14.7917ZM7.74898 11.7917H12.2439C12.3974 11.7917 12.5271 11.7403 12.6328 11.6375C12.7386 11.5346 12.7915 11.4069 12.7915 11.2545C12.7915 11.102 12.7397 10.9728 12.6362 10.8671C12.5327 10.7613 12.4041 10.7084 12.2506 10.7084H7.75571C7.60221 10.7084 7.47258 10.7598 7.36682 10.8627C7.26105 10.9655 7.20817 11.0932 7.20817 11.2457C7.20817 11.3982 7.25993 11.5273 7.36344 11.6331C7.46697 11.7388 7.59548 11.7917 7.74898 11.7917ZM5.75034 17.5834C5.375 17.5834 5.05887 17.4539 4.80192 17.1948C4.54498 16.9358 4.4165 16.6187 4.4165 16.2436V3.7565C4.4165 3.38139 4.54602 3.06432 4.80505 2.80529C5.06407 2.54626 5.38114 2.41675 5.75625 2.41675H11.6473C11.8234 2.41675 11.993 2.4488 12.156 2.51292C12.319 2.57701 12.4688 2.67744 12.6056 2.81419L15.1857 5.39427C15.3224 5.53103 15.4229 5.68091 15.487 5.84389C15.5511 6.00687 15.5831 6.17644 15.5831 6.3526V16.2436C15.5831 16.6187 15.4535 16.9358 15.1943 17.1948C14.9351 17.4539 14.6179 17.5834 14.2425 17.5834H5.75034ZM11.4165 5.9135V3.50006H5.75625C5.69214 3.50006 5.63337 3.52677 5.57994 3.58019C5.52652 3.63362 5.49982 3.69239 5.49982 3.7565V16.2436C5.49982 16.3077 5.52652 16.3665 5.57994 16.4199C5.63337 16.4734 5.69214 16.5001 5.75625 16.5001H14.2434C14.3075 16.5001 14.3663 16.4734 14.4197 16.4199C14.4731 16.3665 14.4998 16.3077 14.4998 16.2436V6.58337H12.0864C11.8953 6.58337 11.7358 6.51951 11.6081 6.39177C11.4804 6.26405 11.4165 6.10462 11.4165 5.9135Z"
          }
        )
      )
    );
  }
);
export {
  DocumentDocIcon
};
